// 过滤无效参数
export const filterInvalid = params => {
  const res = {}
  Object.keys(params).forEach(key => {
    const param = params[key]
    if (
      param === null
      || param === ''
      || param === undefined
      || (Object.prototype.toString.call(param) === '[object Array]' && param.length < 1)
      || (Object.prototype.toString.call(param) === '[object Object]' && Object.keys(param).length < 1)
    ) return
    res[key] = param
  })
  return res
}
// 驼峰转下划线 (eq. world1World2 --> world1_world2)
export const camel2underLine = data => Object.keys(data).length < 1 ? data : Object.keys(data).reduce((val, key) => {
  const _key = key.replace(/([A-Z])/g, match => `_${match.toLowerCase()}`)
  val[_key] = data[key]
  return val
}, {})
// 下划线转驼峰 (eq. world1_world2 --> world1World2)
export const underLine2camel = data => 
  Object.prototype.toString.call(data) !== '[object Object]' || Object.keys(data).length < 1 ?
  data :
  Object.keys(data).reduce((val, key) => {
  const _key = key.split('_').map((item, index) =>
    item.length > 1 && index > 0 ? `${item.slice(0, 1).toUpperCase() + item.slice(1)}` : item
  ).join('')
  val[_key] = data[key]
  return val
}, {})

export const isForeignCurrency = currency => {
  return currency !== 1
}

export const isHKOrTWClient = use_zone => {
  return ['HK', 'TW'].includes(use_zone);
}

export const isTWClient = use_zone => {
  return ['TW'].includes(use_zone);
}

export const isHKClient = use_zone => {
  return ['HK'].includes(use_zone);
}

export const isOversea = val => val == 1
